import React from "react";

import { Link } from "react-router";

import { Subscribe } from "unstated";

import { ProfileContainer } from "./containers/profile-container";

import { Form, Field } from "react-final-form";

import { FORM_ERROR } from "final-form";

import { withRouter } from "react-router";

import { TextInput } from "../components/ui/text-input";
import { FormErrors } from "../components/ui/form-errors";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { PasswordToggle } from "./ui/password-toggle";

import _ from "lodash";

import {
  required,
  composeField,
  passwordConfirmation,
  composeForm
} from "../lib/form-validators";

import PublicPage from "./public-page";

import navigation from "../lib/navigation-utilities";

const PasswordReset = ({ params }) => {
  const onSubmit = (profileContainer) => async (values) =>
    profileContainer
      .updatePassword(params.resetToken, values.password)
      .then(() => navigation.replace("/"))
      .catch(() => {
        return { [FORM_ERROR]: "Failed to update password" };
      });

  return (
    <Subscribe to={[ProfileContainer]}>
      {(profileContainer) => (
        <PublicPage>
          <div className="content text-center align-items-center">
            <Form
              validate={composeForm(
                passwordConfirmation("password", "password_confirmation")
              )}
              onSubmit={onSubmit(profileContainer)}
              render={({
                handleSubmit,
                submitting,
                submitError,
                dirtySinceLastSubmit
              }) => (
                <form onSubmit={handleSubmit}>
                  <Field
                    name="password"
                    inputClass="dc-login_input"
                    containerStyle="form-group input-group"
                    validate={composeField(required)}
                    render={TextInput}
                    placeholder="Password"
                    type="password"
                    prependValue={
                      <div className="dc-login_icon">
                        <FontAwesomeIcon
                          icon={["fas", "lock"]}
                          size="sm"
                          color="#69717a"
                        />
                      </div>
                    }
                    appendValue={(input) => <PasswordToggle inputRef={input} />}
                  />

                  <Field
                    name="password_confirmation"
                    inputClass="dc-login_input"
                    containerStyle="form-group input-group mb-5"
                    validate={composeField(required)}
                    render={TextInput}
                    placeholder="Confirm Password"
                    type="password"
                    prependValue={
                      <div className="dc-login_icon">
                        <FontAwesomeIcon
                          icon={["fas", "lock"]}
                          size="sm"
                          color="#69717a"
                        />
                      </div>
                    }
                    appendValue={(input) => <PasswordToggle inputRef={input} />}
                  />

                  <FormErrors
                    submitError={submitError}
                    dirtySinceLastSubmit={dirtySinceLastSubmit}
                  />

                  <button
                    type="submit"
                    className="btn btn-primary btn-xl w-100 text-uppercase"
                    disabled={submitting}>
                    Reset Password
                  </button>
                </form>
              )}
            />
            <div className="footer text-center mt-5">
              <Link className="text-uppercase" to="/">
                Login
              </Link>
            </div>
          </div>
        </PublicPage>
      )}
    </Subscribe>
  );
};

export default withRouter(PasswordReset);
